"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentMethodTypes = exports.InvoiceStatus = exports.SubscriptionPriceOnCheckoutActions = exports.OrderActionTypes = void 0;
var OrderActionTypes;
(function (OrderActionTypes) {
    OrderActionTypes["INCREMENT_LIMIT"] = "INCREMENT_LIMIT";
    OrderActionTypes["SEND_OTS_QR_CODES"] = "SEND_OTS_QR_CODES";
    OrderActionTypes["RENEW_SUBSCRIPTION"] = "RENEW_SUBSCRIPTION";
    OrderActionTypes["CREATE_SUBSCRIPTION"] = "CREATE_SUBSCRIPTION";
    OrderActionTypes["UPGRADE_SUBSCRIPTION"] = "UPGRADE_SUBSCRIPTION";
    OrderActionTypes["DOWNGRADE_SUBSCRIPTION"] = "DOWNGRADE_SUBSCRIPTION";
})(OrderActionTypes || (exports.OrderActionTypes = OrderActionTypes = {}));
var SubscriptionPriceOnCheckoutActions;
(function (SubscriptionPriceOnCheckoutActions) {
    SubscriptionPriceOnCheckoutActions["UPGRADE"] = "UPGRADE";
    SubscriptionPriceOnCheckoutActions["DOWNGRADE"] = "DOWNGRADE";
    SubscriptionPriceOnCheckoutActions["FORBIDDEN"] = "FORBIDDEN";
    SubscriptionPriceOnCheckoutActions["NEW_SUBSCRIPTION"] = "NEW_SUBSCRIPTION";
})(SubscriptionPriceOnCheckoutActions || (exports.SubscriptionPriceOnCheckoutActions = SubscriptionPriceOnCheckoutActions = {}));
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["PAID"] = "paid";
    InvoiceStatus["FAILED"] = "failed";
    InvoiceStatus["PENDING"] = "pending";
    InvoiceStatus["EXPIRED"] = "expired";
    InvoiceStatus["REFUNDED"] = "refunded";
    InvoiceStatus["REFUNDING"] = "refunding";
})(InvoiceStatus || (exports.InvoiceStatus = InvoiceStatus = {}));
var PaymentMethodTypes;
(function (PaymentMethodTypes) {
    PaymentMethodTypes["PAYPAL"] = "PAYPAL";
    PaymentMethodTypes["MANUAL"] = "MANUAL";
    PaymentMethodTypes["COUPON"] = "COUPON";
    PaymentMethodTypes["CREDIT_CARD"] = "CREDIT_CARD";
})(PaymentMethodTypes || (exports.PaymentMethodTypes = PaymentMethodTypes = {}));
